import React from 'react';
import Icon from '@mdi/react';
import {
  mdiViewDashboard,
  mdiAccountBox,
  mdiNotebookOutline,
  mdiBookshelf,
  mdiCalendarMonth,
  mdiAccountGroup,
  mdiSchool,
  mdiAccountCog,
  mdiChevronRightCircle,
} from '@mdi/js';

const Icons = ({ color, icon }) => {
  if (icon === 'view-dashboard')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiViewDashboard} size={0.65} />
      </span>
    );

  if (icon === 'account-box')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiAccountBox} size={0.65} />
      </span>
    );

  if (icon === 'notebook-outline')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiNotebookOutline} size={0.65} />
      </span>
    );

  if (icon === 'bookshelf')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiBookshelf} size={0.65} />
      </span>
    );

  if (icon === 'calendar-month')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiCalendarMonth} size={0.65} />
      </span>
    );

  if (icon === 'account-group')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiAccountGroup} size={0.65} />
      </span>
    );

  if (icon === 'school')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiSchool} size={0.65} />
      </span>
    );

  if (icon === 'account-cog')
    return (
      <span style={{ paddingTop: 4, marginRight: 10 }}>
        <Icon path={mdiAccountCog} size={0.65} />
      </span>
    );
  return (
    <span style={{ paddingTop: 4, marginRight: 10 }}>
      <Icon path={mdiChevronRightCircle} size={0.65} />
    </span>
  );
};

export default Icons;
